import { Shark, Utils, View } from "shark-mvc";

import Customer from "../../models/Customer";

import templateContent from "./customers.html";

import mainNavComponent from "../../components/mainNav/mainNavComponent";
import userManager from "../../controllers/userManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import customerManager from "../../controllers/customerManager";
import ApiKey from "../../models/ApiKey";

class CustomersView extends View {
	route = "customers";

	constructor () {
		super("customersView");
		this.setTemplate(templateContent);
	}

	addApiKeyBtn_clickHandler () {
		const currApiKey = new ApiKey();

		Shark.set({
			currApiKey,
		});
	}

	addCustomerBtn_clickHandler () {
		const newCustomer = new Customer({
			title: "Nuovo Client",
		});

		Shark.set({
			currCustomer: newCustomer,
		});
	}

	beforeLoad () {
		window.scrollTo(0, 0);
		this.refreshList();
	}

	init () {
		this.addComponents([mainNavComponent, waitBoxComponent]);

		Shark.set({
			currApiKey: null,
			currCustomer: null,
			customerList: [],
		});
	}

	refreshList () {
		const sorting = {
			name: "ASC",
		};
		const range = {
			first: 0,
			length: 50,
		};

		customerManager.getList({sorting, range})
		.then(getListResponse => {
			if (getListResponse.data) {
				const customerList = Shark.getInstanceList(Customer, getListResponse.data);
				
				Utils.reindexList(customerList);
				
				Shark.set({
					customerList,
				});
			}
		});
	}

	async saveCurrCustomerBtn_clickHandler () {
		const { currCustomer } = Shark.get();

		if (currCustomer) {
			waitBoxComponent.open();
			
			const result = await customerManager.save(currCustomer);
			console.log({result});
			
			await this.refreshList();
			
			waitBoxComponent.close();
		}
	}
}

const customersView = new CustomersView();

Shark.registerView(customersView);

export default customersView;
